<template>
  <v-container grid-list-md>
    <v-slide-y-transition mode="out-in">
      <v-flex md8 offset-md2>
        <v-card>
          <v-toolbar flat color="grey lighten-3">
            <v-btn icon @click="close()">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title v-if="notification.NotificationID">Notification</v-toolbar-title>
            <v-toolbar-title v-if="!notification.NotificationID">Add Notification</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap="">
                <v-flex xs12>
                  <v-select
                    :items="actions"
                    v-model="notification.ActionID"
                    @change="actionChange"
                    label="Action"
                    required
                    :rules="[v => !!v || 'Required']"
                    item-text="ActionName"
                    item-value="ActionID"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :items="responseValues"
                    v-model="notification.notificationType"
                    label="Notification Type"
                    required
                    :rules="[v => !!v || 'Required']"
                    item-text="label"
                    item-value="value"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :items="users"
                    v-model="notification.UserID"
                    label="Send Notification To"
                    item-value="UserID"
                    required
                    :rules="[v => !!v || 'Required']"
                  >
                    <template slot="selection" slot-scope="data">
                      <span class="uppercase">{{ data.item.LastName }}, {{ data.item.FirstName }}</span>
                    </template>
                    <template slot="item" slot-scope="data">
                      <span class="uppercase">{{ data.item.LastName }}, {{ data.item.FirstName }}</span>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="this.loggedInUser.securityMask.charAt(parseInt(this.access['NotificationDelete'])-1) == '1' && notification.NotificationID"
              flat
              color="red"
              @click="showDeleteDialog()"
            >Delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn flat color="blue" v-if="this.loggedInUser.securityMask.charAt(parseInt(this.access['NotificationSave'])-1) == '1'" @click="save()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-slide-y-transition>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Delete?</v-card-title>
        <v-card-text>Are you sure you want to delete this notification?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="deleteNotification">Yes</v-btn>
          <v-btn color="green darken-1" flat="flat" @click="dialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import RestService from '../services/RestService';
import * as Sentry from '@sentry/browser';

const service = new RestService();

export default {
  name: 'Notification',
  props: {
    userId: String,
    actionId: String,
    notificationId: String
  },
  data() {
    return {
      loggedInUser: {},
      access: {},
      dialog: false,
      valid: false,
      notification: {},
      users: [],
      actions: [],
      responseTypes: [],
      responseValues: []
    };
  },
  methods: {
    close() {
      this.$router.go(-1);
    },
    save() {
      if (this.$refs.form.validate()) {
        service
          .saveNotification(this.notification)
          .then(response => {
            this.$router.go(-1);
          })
          .catch(e => {
            console.log(e);
            Sentry.captureException(e);
          });
      }
    },
    validate() {
      if (this.notification.ActionID == null) {
      }
      return true;
    },
    actionChange(actionId) {
      for (let i = 0; i < this.actions.length; i++) {
        let a = this.actions[i];
        if (a.ActionID == actionId) {
          this.setResponseValues(a.RspsType);
        }
      }
    },
    setResponseValues(type) {
      switch (type) {
        case '1':
          this.responseValues = [
            { label: 'Affirmative', value: '10' },
            { label: 'Negative', value: '20' },
            { label: 'No Response', value: '99' }
          ];
          break;
        case '2':
          this.responseValues = [
            { label: 'Affirmative', value: '10' },
            { label: 'Negative', value: '20' },
            { label: 'Text', value: '30' },
            { label: 'No Response', value: '99' }
          ];
          break;
        case '3':
          this.responseValues = [
            { label: 'Text', value: '30' },
            { label: 'No Response', value: '99' }
          ];
          break;
      }
    },
    showDeleteDialog() {
      this.dialog = true;
    },
    deleteNotification() {
      this.dialog = false;
      service
        .deleteNotificationById(this.notification.NotificationID)
        .then(response => {
          this.close();
        })
        .catch(e => {
          console.log(e);
          Sentry.captureException(e);
        });
    }
  },
  created() {
    this.loggedInUser = this.$store.getters['auth/user'];
    this.access = this.$store.getters['auth/access'];
    if (this.notificationId) {
      this.notification.NotificationID = this.notificationId;
      service
        .getNotificationById(this.notificationId)
        .then(response => {
          let n = response.data.body[0];
          this.notification.notificationType = n.notificationType;
          this.notification.UserID = n.UserID;
          this.actionChange(this.actionId);
        })
        .catch(e => {
          console.log(e);
          Sentry.captureException(e);
        });
    }
    this.notification.ActionID = this.actionId;
    service
      .getUserActions(this.userId)
      .then(response => {
        this.actions = response.data.body;
        this.actionChange(this.actionId);
      })
      .catch(e => {
        console.log(e);
        Sentry.captureException(e);
      });
    // get list of users to populate users dropdown
    let user = this.$store.getters['auth/user'];
    service
      .getUsersByParent(user.UserID)
      .then(response => {
        if (response.data.body.length > 0) {
          this.users = response.data.body;
        }
      })
      .catch(e => {
        console.log(e);
        Sentry.captureException(e);
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
